import { Td } from "@chakra-ui/react";

export const TableHeadMobile = () => {
  return (
    <>
      <Td> Product Name</Td>
      <Td> Category</Td>
      <Td> Total Clicks</Td>
    </>
  );
};
